import { AbstractControl, ValidationErrors } from '@angular/forms';

export function minArrayLengthValidator(min: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!Array.isArray(value)) return { notArray: true };
    return value.length >= min ? null : {
      minArrayLength: { requiredLength: min, actualLength: value.length }
    };
  };
}